{
    "Accessibility Menu": "Menu Aksesibiliti",
    "Reset settings": "Tetapkan semula tetapan",
    "Close": "Tutup",
    "Content Adjustments": "Penyesuaian Kandungan",
    "Adjust Font Size": "Laraskan Saiz Fon",
    "Highlight Title": "Serlahkan Tajuk",
    "Highlight Links": "Serlahkan Pautan",
    "Readable Font": "Fon Mudah Baca",
    "Color Adjustments": "Penyesuaian Warna",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Bantuan Visual dan Navigasi",
    "Additional Tools": "Alat Tambahan",
    "Reading Guide": "Panduan Membaca",
    "Stop Animations": "Hentikan Animasi",
    "Big Cursor": "Kursor Besar",
    "Screen Reader": "Pembaca Skrin",
    "Hide Images": "Sembunyikan Gambar",
    "Image Tooltips": "Petunjuk Gambar",
    "Page Structure": "Struktur Halaman",
    "Super Focus": "Super Fokus",
    "Magnifier": "Kanta Pembesar",
    "Increase Font Size": "Besarkan Saiz Fon",
    "Decrease Font Size": "Kecilkan Saiz Fon",
    "Letter Spacing": "Ruangan Huruf",
    "Line Height": "Ketinggian Garis",
    "Font Weight": "Ketebalan Fon",
    "Dyslexia Font": "Fon Dyslexia",
    "Language": "Bahasa",
    "Open Accessibility Menu": "Buka menu kebolehcapaian",
    "Accessibility Profiles": "Profil Kebolehcapaian",
    "Seizure Safe Profile": "Profil Selamat untuk Sawan",
    "Stops animations and reduces color saturation.": "Menghentikan animasi dan mengurangkan ketepuan warna.",
    "Blind Profile": "Profil untuk Orang Buta",
    "Activates the screen reader for auditory navigation.": "Mengaktifkan pembaca skrin untuk navigasi auditori.",
    "Visually Impaired Profile": "Profil untuk Penglihatan Lemah",
    "Enhances contrast and readability for low vision.": "Meningkatkan kontras dan kebolehbacaan untuk penglihatan rendah.",
    "ADHD Friendly Profile": "Profil Mesra ADHD",
    "Reduces distractions for better focus.": "Mengurangkan gangguan untuk fokus yang lebih baik.",
    "Cognitive & Learning Profile": "Profil Kognitif dan Pembelajaran",
    "Helpful tools for reading and comprehension.": "Alat berguna untuk membaca dan pemahaman.",
    "Motor Impaired Profile": "Profil untuk Kecacatan Motor",
    "Optimizes the site for keyboard-only navigation.": "Mengoptimumkan laman untuk navigasi menggunakan papan kekunci sahaja.",
    "Headings": "Tajuk",
    "Landmarks": "Penanda",
    "Links": "Pautan",
    "Focus element": "Fokus elemen",
    "Visit link": "Lawati pautan"
}